export default __webpack_public_path__ + "static/media/corner-bison.3e242e9a.webp";